const LINK_TARGETS = {
    CURRENT_TAB: 'currentTab',
    NEW_TAB: 'newTab',
};

export default LINK_TARGETS;